module.exports = __webpack_public_path__ + "img/logo.d5441057.jpg";